import { Helper } from 'dxf';


export interface DxfBounds {
    minX: number, minY: number, width: number, height: number
}

export const svgStringToBoundingBox = (
    dxfString: string
): DxfBounds | null => {
    const helper = new Helper(dxfString);
    let svg = helper.toSVG();
    svg = svg.replace(/stroke=".*?"/g, `stroke="${'white'}"`);
    svg = svg.replace(/preserveAspectRatio=".*?"/g, "");
    svg = svg.replace(/stroke-width=".*?"/g, `stroke-width="1%"`);
    // const svgString = this.sanitizer.bypassSecurityTrustHtml(svg);
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, 'image/svg+xml');
    const svgElement = doc.querySelector('svg');

    if (!svgElement) {
        console.error('No SVG element found.');
        return null;
    }

    const viewBoxAttr = svgElement.getAttribute('viewBox');
    if (!viewBoxAttr) {
        console.error('No viewBox attribute found.');
        return null;
    }

    const viewBoxValues = viewBoxAttr.trim().split(/\s+/).map(Number);
    if (viewBoxValues.length !== 4 || viewBoxValues.some(isNaN)) {
        console.error('Invalid viewBox format.');
        return null;
    }

    const [minX, minY, width, height] = viewBoxValues;
    return { minX, minY, width, height };
}
